module.exports = __webpack_public_path__ + "static/img/paste-icon.2ee0df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/test/paste-icon.png
// module id = /25i
// module chunks = 4